import React from 'react';
import ReactQuill from 'react-quill';

import {QuillToolbar} from 'components/rich-text';
import {FileDownloadAnchorInterceptor} from 'features/intercept-file-download-anchor';

export interface IRichTextEditorProps {
    placeholder?: string;
    value?: string;
    onChange?: (value: any) => void;
    disabled?: boolean;
    toolbarId?: string;
}

export const RichTextEditor = ({disabled, ...props}: IRichTextEditorProps) => {
    const modules = {
        toolbar: {
            container: `#toolbar-${props.toolbarId}`,
        },
    };

    return (
        <FileDownloadAnchorInterceptor>
            <ReactQuill
                theme="snow"
                readOnly={disabled}
                modules={modules}
                {...props}
            />
            <QuillToolbar
                toolbarHtmlId={`toolbar-${props.toolbarId}`}
                disabled={disabled}
            />
        </FileDownloadAnchorInterceptor>
    );
};
